var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"order.create.label","bread-crumb-data":_vm.breadCrumbData}},[(_vm.order)?_c('order-form',{attrs:{"order":_vm.order}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }